/**
 * 防抖函数
 * @param {*} func 
 * @param {*} wait 
 * @param {*} immediate 
 * @desc 防抖 https://github.com/mqyqingfeng/Blog/issues/22
 */
export function debounce(func, wait = 200, immediate) {
  var timeout, result;
  var debounced = function () {
    var context = this;
    var args = arguments;
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过，不再执行
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) result = func.apply(context, args)
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
    return result;
  };
  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };
  return debounced;
}

/**
 * 加密
 * @param string $plainText 明文
 * @return bool|string
 */
export function encrypt(plainText) {
  // var securityKey16 = 'Skesj(eE%32sLOap';
  // var securityKey24 = 'Skesj(eE%32sLOapA9e2snEw';
  // var securityKey32 = 'Skesj(eE%32sLOapA9e2snEwEeopsWui';
  var token = localStorage.getItem('authToken');
  var config = {
    'securityKey': token.slice(0, 32),
    'iv': token.slice(0, 16),
  };
  var CryptoJS = window.CryptoJS;
  var securityKey = CryptoJS.enc.Utf8.parse(config.securityKey);
  var iv = CryptoJS.enc.Utf8.parse(config.iv);
  var encrypted = CryptoJS.AES.encrypt(String(plainText), securityKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

/**
 * 格式化时间 
 * @param {*} time 
 * @param {String} format
 * @returns YY-MM-DD
 */
export function formatDate(time, format) {
  var date = new Date(time);
  var Y = date.getFullYear();
  var M = (date.getMonth() + 1).toString().padStart(2, '0');
  var D = date.getDate().toString().padStart(2, '0');
  var h = date.getHours().toString().padStart(2, '0');
  var m = date.getMinutes().toString().padStart(2, '0');
  var s = date.getSeconds().toString().padStart(2, '0');
  return format === 'YYYY-MM-DD hh:mm:ss' ? `${Y}-${M}-${D} ${h}:${m}:${s}` : `${Y}-${M}-${D}`;
}

/**
 * 是否数字
 */
export function isNumber(value) {
  return typeof value === 'number' && !isNaN(value)
}

/**
 * 滚动到指定位置
 * @param {Number} target 指定scrollTop
 * @param {String} id 元素id
 */
export function scrollToTarget(target, id, callback) {
  const dom = id ? document.getElementById(String(id)) : (document.body || document.documentElement);
  if (!dom) return;
  if (!isNumber(target) || target < 0) return;
  let scrollT = dom.scrollTop;
  let step;
  const type = scrollT < target ? 1 : 2; //1-向下，2-向上
  const timer = setInterval(function () {
    scrollT = dom.scrollTop;
    if (type == 1) {
      step = Math.ceil((target - scrollT) / 3);
    } else {
      step = Math.floor((target - scrollT) / 3);
    }
    dom.scrollTop = scrollT + step;
    if ((type == 1 && dom.scrollTop >= target) || (type == 2 && dom.scrollTop <= target)) {
      dom.scrollTop = target;
      clearInterval(timer);
      callback && callback()
    }
  }, 20)
}

/**
 * 获取月最后一天
 * @param {*} time 
 * boolean标识是否需要判断时间，默认不需要判断
 */
export function getMonthLastDay(time, boolean) {
  const date = new Date(time);
  const Y = date.getFullYear();
  const M = (date.getMonth() + 1).toString().padStart(2, '0');
  const D = new Date(Y, M, 0).getDate().toString().padStart(2, '0');
  if (boolean && new Date(`${Y}-${M}-${D} 23:59:59`).getTime() > Date.now()) {
    const today = new Date();
    const TY = today.getFullYear();
    const TM = (today.getMonth() + 1).toString().padStart(2, '0');
    const TD = today.getDate().toString().padStart(2, '0');
    return `${TY}-${TM}-${TD}`
  }
  return `${Y}-${M}-${D}`;
}

/**
 * 获取月的第一天或最后一天
 * @param {*} time 
 * boolean标识是第一天还是最后一天
 */
export function getDayOfMonth(time, boolean) {
  const date = new Date(time);
  const Y = date.getFullYear();
  const M = (date.getMonth() + 1).toString().padStart(2, '0');
  const D = new Date(Y, M, 0).getDate().toString().padStart(2, '0');
  return boolean ? `${Y}-${M}-01` : `${Y}-${M}-${D}`;
}

/**
 * 获取指定周的某一天
 * @param {*} year  年
 * @param {*} week  周数
 * @param {*} day   周几  1-7 表示周一到周日
 * @returns 
 */
export function getDateOfISOWeek(year, week, day = 1) {
  var simple = new Date(year, 0, 1 + (week - 1) * 7);//获取当年的一月一号，
  var dow = simple.getDay();//获取一月一号是周几
  var ISOweekStart = simple;
  //判断第一周有几天,
  if (dow <= 4) {
    ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  } else {
    ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  }
  day = day <= 7 ? day : 1;
  return formatDate(new Date(ISOweekStart).getTime() + (day - 1) * 1000 * 60 * 60 * 24);
}

/**
 * 下载文件
 */
export function downloadFile(url, name = 'image.png') {
  var a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
}
/**
 * 
 * @param {*} url  图片链接
 * @param {*} filename  保存的文件名
 */
export function downloadImage(url, filename = 'image') {
  const mime = url.endsWith('png') ? 'png' : 'jpeg';
  const img = new Image();
  img.crossOrigin = 'Anonymous'; // 设置跨域请求

  img.onload = function () {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    canvas.toBlob(function (blob) {
      const urlObject = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = urlObject;
      link.download = filename + '.' + mime;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(urlObject);
    }, `image/${mime}`);
  };

  img.onerror = function () {
    console.error('Failed to load image');
  };

  img.src = url;
}